var _path, _g, _g2, _path2, _path3, _g3, _g4, _path4, _path5, _path6, _path7, _g5, _g6, _path8, _path9, _g7, _g8, _path0, _g9, _g0, _g1, _g10, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path1, _circle, _circle2, _g11, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgLogoProducts = function SvgLogoProducts(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79 103",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.51 19.3806C38.5788 18.8145 39.8587 18.8145 40.9275 19.3806L73.3701 36.5625L39.2188 54.6493L5.06742 36.5625L37.51 19.3806Z",
    fill: "url(#logo-products_svg__paint0_linear_10099_8352)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter0_i_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0675 82.2193V36.5024L39.3871 54.5549V102.049L6.78777 85.056C5.73053 84.5049 5.0675 83.4116 5.0675 82.2193Z",
    fill: "url(#logo-products_svg__paint1_linear_10099_8352)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter1_i_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.387 82.1698V36.5625L39.3868 54.5391V102.049L71.419 85.4098C72.6282 84.7817 73.387 83.5324 73.387 82.1698Z",
    fill: "url(#logo-products_svg__paint2_linear_10099_8352)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6687 19.1768C38.5311 18.7018 39.5747 18.6933 40.4447 19.1541L73.2019 36.5026C73.2019 36.5026 52.6006 30.3734 39.0506 30.3734C25.5006 30.3734 21.8625 27.8818 21.8625 27.8818L37.6687 19.1768Z",
    fill: "url(#logo-products_svg__paint3_linear_10099_8352)",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5289 52.9924L30.8642 61.1141L15.5289 69.2357L0.193685 61.1141L15.5289 52.9924Z",
    fill: "url(#logo-products_svg__paint4_linear_10099_8352)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter2_i_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.193726 82.4866V61.0869L15.6045 69.2227V90.5199L0.193726 82.4866Z",
    fill: "url(#logo-products_svg__paint5_linear_10099_8352)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter3_i_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8717 82.5896V61.1284L15.6043 69.2232V90.5205L30.8717 82.5896Z",
    fill: "url(#logo-products_svg__paint6_linear_10099_8352)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5343 52.9922L30.7885 61.0872C30.7885 61.0872 21.5377 58.335 15.4533 58.335C9.36879 58.335 7.67102 57.1602 7.67102 57.1602L15.5343 52.9922Z",
    fill: "url(#logo-products_svg__paint7_linear_10099_8352)",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9507 39.5159L27.0678 34.4775L39.3438 41.0754L28.1074 46.6336L17.9507 39.5159Z",
    fill: "url(#logo-products_svg__paint8_linear_10099_8352)",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7059 65.2486L48.5829 60.3301L48.5829 81.8431L34.9473 88.6009L39.7059 65.2486Z",
    fill: "url(#logo-products_svg__paint9_linear_10099_8352)",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4871 11.4807C38.8711 11.2774 39.3308 11.2774 39.7148 11.4807L51.3691 17.653L39.101 24.1503L26.8328 17.653L38.4871 11.4807Z",
    fill: "url(#logo-products_svg__paint10_linear_10099_8352)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter4_i_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8328 34.0547V17.6318L39.1614 24.1404V41.1783L27.4507 35.0738C27.0709 34.8758 26.8328 34.483 26.8328 34.0547Z",
    fill: "url(#logo-products_svg__paint11_linear_10099_8352)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter5_i_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3749 34.0364V17.6641L39.161 24.1399V41.1777L50.6679 35.2003C51.1023 34.9746 51.3749 34.5259 51.3749 34.0364Z",
    fill: "url(#logo-products_svg__paint12_linear_10099_8352)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5439 11.4076C38.8536 11.237 39.2285 11.234 39.5411 11.3995L51.3085 17.6316C51.3085 17.6316 43.9078 15.4298 39.0403 15.4298C34.1727 15.4298 32.8658 14.5347 32.8658 14.5347L38.5439 11.4076Z",
    fill: "url(#logo-products_svg__paint13_linear_10099_8352)",
    fillOpacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5388 52.3522L78.8741 60.4739L63.5388 68.5956L48.2036 60.4739L63.5388 52.3522Z",
    fill: "url(#logo-products_svg__paint14_linear_10099_8352)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter6_i_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2037 80.9754V60.4468L63.6145 68.5825V89.8798L48.9762 82.2492C48.5015 82.0017 48.2037 81.5108 48.2037 80.9754Z",
    fill: "url(#logo-products_svg__paint15_linear_10099_8352)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter7_i_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.8817 81.9495V60.4883L63.6144 68.5831V89.8803L78.8817 81.9495Z",
    fill: "url(#logo-products_svg__paint16_linear_10099_8352)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5146 52.3789L78.8076 60.4687C78.8076 60.4687 69.5479 57.6948 63.4634 57.6948C57.3789 57.6948 55.6982 56.5039 55.6982 56.5039L63.5146 52.3789Z",
    fill: "url(#logo-products_svg__paint17_linear_10099_8352)",
    fillOpacity: 0.4
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter8_f_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9877 36.6191L16.3934 45.2564V56.9326L4.39722 63.1706V73.4073",
    stroke: "#041313",
    strokeOpacity: 0.55,
    strokeWidth: 0.639794,
    strokeLinecap: "round"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter9_f_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5443 36.1392L57.82 45.2562V56.9325L70.3816 65.0778V73.875",
    stroke: "#041313",
    strokeOpacity: 0.28,
    strokeWidth: 0.639794,
    strokeLinecap: "round"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter10_f_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1035 36.1392L60.3792 45.2562V56.9325L72.3754 64.61V73.4072",
    stroke: "#041313",
    strokeOpacity: 0.28,
    strokeWidth: 0.639794,
    strokeLinecap: "round"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter11_f_10099_8352)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8321,
    cy: 44.9208,
    rx: 4.71848,
    ry: 2.06387,
    fill: "#1E0404",
    fillOpacity: 0.7
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.91595,
    cy: 76.1664,
    rx: 0.799743,
    ry: 1.2396,
    fill: "#413AC5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1879,
    cy: 29.9212,
    rx: 0.799743,
    ry: 1.2396,
    fill: "#413AC5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.1035,
    cy: 29.9212,
    rx: 0.799743,
    ry: 1.2396,
    fill: "#4E609A"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.0777,
    cy: 30.8612,
    rx: 0.799743,
    ry: 1.2396,
    fill: "#4E609A"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.616,
    cy: 75.2098,
    rx: 0.799743,
    ry: 1.2396,
    fill: "#4E609A"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.855,
    cy: 74.0667,
    rx: 0.799743,
    ry: 1.2396,
    fill: "#4E609A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91583 76.1263L4.18243 78.0463C3.33086 78.4843 2.31763 77.866 2.31763 76.9084V49.6697C2.31763 47.5438 3.48908 45.5907 5.36469 44.5898L33.1877 29.7412",
    stroke: "#52F2F2",
    strokeWidth: 0.639794,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8593,
    cy: 36.9666,
    r: 4.38116,
    fill: "url(#logo-products_svg__paint18_linear_10099_8352)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-products_svg__mask0_10099_8352",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 32,
    width: 10,
    height: 10
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8592,
    cy: 36.9666,
    r: 4.38116,
    fill: "url(#logo-products_svg__paint19_linear_10099_8352)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-products_svg__mask0_10099_8352)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter12_f_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9453 38.6715C21.4946 40.1449 21.6691 35.5467 20.3008 34.1995C18.9326 32.8523 16.5397 35.2663 17.9905 33.7928C19.4412 32.3194 21.7265 32.2171 23.0947 33.5643C24.463 34.9115 24.3961 37.1981 22.9453 38.6715Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter13_f_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6182 34.3434C24.3614 35.9594 19.3715 35.5947 18.0564 37.0133C16.7412 38.432 19.5988 41.0968 17.8557 39.4807C16.1125 37.8647 15.7655 35.4047 17.0806 33.986C18.3958 32.5674 20.875 32.7274 22.6182 34.3434Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter14_f_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1674 39.286C16.2795 38.4353 18.8079 40.191 20.4871 40.4123C22.1664 40.6336 22.3606 39.2366 22.2485 40.0872C22.1364 40.9379 20.6842 41.4481 19.005 41.2268C17.3258 41.0055 16.0553 40.1366 16.1674 39.286Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-products_svg__filter15_f_10099_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3739 38.1728C22.1387 40.4671 20.5254 36.4908 19.2874 36.3639C18.0494 36.237 17.6555 40.0075 17.8907 37.7132C18.1259 35.419 19.3201 33.662 20.5582 33.7889C21.7962 33.9158 22.6091 35.8786 22.3739 38.1728Z",
    fill: "#91EEFF"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3416 32.9586C18.9134 32.773 16.0419 33.4107 15.982 37.4458C16.2544 36.0928 17.5077 33.3013 20.3416 32.9586Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1833 30.0615L74.9744 46.484C76.0401 47.1137 76.6939 48.2594 76.6939 49.4972V75.1728C76.6939 75.6665 76.1582 75.9742 75.7317 75.7254L72.8551 74.0474",
    stroke: "#52F2F2",
    strokeWidth: 0.639794,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.184 30.8613L73.5678 48.0208C74.3168 48.4736 74.7744 49.285 74.7744 50.1602V76.2613C74.7744 76.7551 74.2388 77.0628 73.8123 76.814L70.9357 75.136",
    stroke: "#52F2F2",
    strokeWidth: 0.639794,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter0_i_10099_8352",
    x: 5.0675,
    y: 36.5024,
    width: 34.3196,
    height: 66.2771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.730204
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.365102
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter1_i_10099_8352",
    x: 39.3868,
    y: 36.5625,
    width: 34.0001,
    height: 66.217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.730204
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.365102
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter2_i_10099_8352",
    x: 0.193726,
    y: 61.0869,
    width: 15.4108,
    height: 29.761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.32789
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163945
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter3_i_10099_8352",
    x: 15.6044,
    y: 61.1284,
    width: 15.2673,
    height: 29.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.32789
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163945
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter4_i_10099_8352",
    x: 26.8328,
    y: 17.6318,
    width: 12.3286,
    height: 23.8087,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.262312
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.131156
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter5_i_10099_8352",
    x: 39.161,
    y: 17.6641,
    width: 12.2139,
    height: 23.776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.262312
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.131156
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter6_i_10099_8352",
    x: 48.2037,
    y: 60.4468,
    width: 15.4108,
    height: 29.761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.32789
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163945
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter7_i_10099_8352",
    x: 63.6144,
    y: 60.4883,
    width: 15.2673,
    height: 29.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.32789
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163945
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter8_f_10099_8352",
    x: 2.15789,
    y: 34.3799,
    width: 34.0691,
    height: 41.2665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.959691,
    result: "effect1_foregroundBlur_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter9_f_10099_8352",
    x: 42.305,
    y: 33.9,
    width: 30.3159,
    height: 42.2143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.959691,
    result: "effect1_foregroundBlur_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter10_f_10099_8352",
    x: 44.8642,
    y: 33.9,
    width: 29.7505,
    height: 41.7465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.959691,
    result: "effect1_foregroundBlur_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter11_f_10099_8352",
    x: 9.99529,
    y: 37.7386,
    width: 19.6737,
    height: 14.3646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.55918,
    result: "effect1_foregroundBlur_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter12_f_10099_8352",
    x: 16.1762,
    y: 31.2542,
    width: 9.2656,
    height: 9.06785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.681513,
    result: "effect1_foregroundBlur_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter13_f_10099_8352",
    x: 14.9198,
    y: 31.6555,
    width: 9.42674,
    height: 9.69187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.681513,
    result: "effect1_foregroundBlur_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter14_f_10099_8352",
    x: 14.7975,
    y: 37.6917,
    width: 8.83982,
    height: 4.94969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.681513,
    result: "effect1_foregroundBlur_10099_8352"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-products_svg__filter15_f_10099_8352",
    x: 13.5423,
    y: 29.4984,
    width: 13.156,
    height: 13.6696,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.1419,
    result: "effect1_foregroundBlur_10099_8352"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint0_linear_10099_8352",
    x1: 48.8797,
    y1: 20.2145,
    x2: 34.2756,
    y2: 50.8831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint1_linear_10099_8352",
    x1: 22.2273,
    y1: 45.0413,
    x2: 22.2273,
    y2: 120.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint2_linear_10099_8352",
    x1: 56.3869,
    y1: 46.5018,
    x2: 56.3869,
    y2: 118.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint3_linear_10099_8352",
    x1: 52.9266,
    y1: 22.6267,
    x2: 28.517,
    y2: 42.4271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCD4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint4_linear_10099_8352",
    x1: 19.8671,
    y1: 53.7732,
    x2: 13.3093,
    y2: 67.5446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint5_linear_10099_8352",
    x1: 7.89913,
    y1: 64.9212,
    x2: 7.89913,
    y2: 98.6938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint6_linear_10099_8352",
    x1: 23.238,
    y1: 65.5775,
    x2: 23.238,
    y2: 97.8746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88C1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint7_linear_10099_8352",
    x1: 21.6841,
    y1: 54.8564,
    x2: 10.7233,
    y2: 63.7476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCD4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint8_linear_10099_8352",
    x1: 33.9455,
    y1: 36.7968,
    x2: 31.0665,
    y2: 43.8345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint9_linear_10099_8352",
    x1: 48.2231,
    y1: 70.4068,
    x2: 40.5855,
    y2: 70.4868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962967,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint10_linear_10099_8352",
    x1: 42.5715,
    y1: 11.7803,
    x2: 37.3252,
    y2: 22.7974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint11_linear_10099_8352",
    x1: 32.9971,
    y1: 20.6993,
    x2: 32.9971,
    y2: 47.7174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint12_linear_10099_8352",
    x1: 45.2679,
    y1: 21.2233,
    x2: 45.2679,
    y2: 47.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88C1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint13_linear_10099_8352",
    x1: 44.0249,
    y1: 12.6469,
    x2: 35.2563,
    y2: 19.7599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCD4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint14_linear_10099_8352",
    x1: 67.8769,
    y1: 53.1331,
    x2: 61.3192,
    y2: 66.9044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint15_linear_10099_8352",
    x1: 55.9091,
    y1: 64.2811,
    x2: 55.9091,
    y2: 98.0537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint16_linear_10099_8352",
    x1: 71.248,
    y1: 64.9374,
    x2: 71.248,
    y2: 97.2345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88C1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint17_linear_10099_8352",
    x1: 69.6942,
    y1: 54.2163,
    x2: 58.7334,
    y2: 63.1074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCD4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint18_linear_10099_8352",
    x1: 19.8593,
    y1: 32.5854,
    x2: 19.8593,
    y2: 41.3478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-products_svg__paint19_linear_10099_8352",
    x1: 19.8592,
    y1: 32.5854,
    x2: 19.8592,
    y2: 41.3478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoProducts);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "static/logo-products.0ff995b5.svg";